import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EntityTypes } from '@app/models/enums/EntityTypes';
import { ColumnVisibilityService } from '@services/column-visibility.service';
import { FilterStateService } from '@services/filter-state.service';
import { ColumnVisibilityComponent } from '@shared/column-visibility/column-visibility.component';
import { OpportunitiesFiltersComponent } from '@shared/opportunities-filters/opportunities-filters.component';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { IconSanitizerService, TabItemComponent, TabViewComponent } from 'ngx-lib';
import { OpportunitiesCalendarComponent } from '../opportunities-calendar/opportunities-calendar.component';
import { OpportunitiesListComponent } from '../opportunities-list/opportunities-list.component';
import { OpportunitiesMapComponent } from '../opportunities-map/opportunities-map.component';

@Component({
    selector: 'app-opportunities-main',
    templateUrl: './opportunities-main.component.html',
    styleUrls: ['./opportunities-main.component.scss'],
    providers: [FilterStateService, ColumnVisibilityService],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SectionHeaderComponent,
        TabViewComponent,
        TabItemComponent,
        OpportunitiesFiltersComponent,
        OpportunitiesListComponent,
        OpportunitiesCalendarComponent,
        OpportunitiesMapComponent,
        ColumnVisibilityComponent
    ]
})
export class OpportunitiesMainComponent implements OnInit {
    currentTab = 'List';

    kanbanIcon?: SafeHtml;
    listIcon?: SafeHtml;
    mapIcon?: SafeHtml;
    calendarIcon?: SafeHtml;
    plusIcon?: SafeHtml;
    entityTypeId = EntityTypes.Opportunity;

    private readonly router = inject(Router);
    private readonly iconSanitizer = inject(IconSanitizerService);

    ngOnInit(): void {
        this.kanbanIcon = this.iconSanitizer.getIcon('kanban');
        this.listIcon = this.iconSanitizer.getIcon('list');
        this.mapIcon = this.iconSanitizer.getIcon('map');
        this.calendarIcon = this.iconSanitizer.getIcon('calendar');
        this.plusIcon = this.iconSanitizer.getIcon('plus');
    }

    onCreateNewOpportunityClicked() {
        this.router.navigate([`/opportunities-create`]);
    }
}
